import '../index.css'

interface ToggleChipProps {
  name: string
  value: boolean
  onClick?: (event: React.ChangeEvent<any>) => void
  label?: string
  disabled?: boolean
}

const ToggleChip: React.FC<ToggleChipProps> = ({ onClick, name, value, label, disabled }) => {

  const onClickAction = (event: React.ChangeEvent<any>) => {
    if (onClick) onClick(event)
  }

  return (
    <div className="toggle-chip__section">
      <button
        disabled={disabled}
        name={name}
        value={value.toString()}
        className={`toggle-chip ${value ? 'checked' : ''}`} onClick={(e) => onClickAction(e)}
      >
        {label}
      </button>
    </div>
  )
}

export default ToggleChip